<template>
  <div class="w-100 contact-page  bg-white px-1">
    <el-dialog :title="'Thêm liên hệ'" :visible.sync="showAddListPhone" :close-on-click-modal="false" width="900px"
               top="40px" destroy-on-close>
      <div class="d-flex">

        <div class="flex-1">
          <div class="d-flex">
            <div class="flex-1">
              <div class="d-flex">
                <el-input placeholder="Thêm số điện thoại" v-model="txtPhone" size="mini" class="flex-1 " />
                <div class="mx-1" />
                <el-button type="primary" size="mini" plain @click="addPhoneN(txtPhone)">Thêm</el-button>
                <div class="mx-1 mt-1">hoặc</div>
                <el-button type="info" @click="upload" size="mini">
                  Tải tệp lên <i class="el-icon-upload el-icon-right"></i>
                  <input @click="$event.target.value = ''" accept=".txt" ref="fileUpload" type="file"
                         style="display: none;" @change="onChange" />
                </el-button>
              </div>
              <div class="d-flex mx-1 mt-1 font-size-14">
                <div class="font-italic  text-danger d-flex">
                  <span class="fw-semibold ">Lưu ý: </span>
                  <div class="mx-1">
                    <div class="d-flex">
                      <div>- Tệp tin được tải lên theo mẫu</div>
                      <div @click="downloadTxt">
                        <a href="#" class="text-decoration-none mx-1 text-info">filemau.txt</a>
                        <img src="/assets/icon/icon_txt.svg" class="pointer" style="max-height: 16px" />
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="mt-1">
                <div class="font-size-16 fw-bold">Số điện thoại ({{ phoneNumbers.length }})</div>
                <div style="min-height: calc(100vh - 400px);max-height: calc(100vh - 400px); overflow-y: auto;">
                  <div v-for="phone in phoneNumbers" :key="phone"
                       class="d-flex justify-content-between py-2 divider-custom ">
                    <div class="flex-1">
                      <div class="font-size-14">{{ phone }}</div>
                    </div>
                    <div>
                      <el-button type="danger" size="mini" plain @click="deletePhone(phone)">Xóa</el-button>
                    </div>
                    <div class="m-1"></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="width: 450px; border-left: 1px solid #DCDFE9;min-height: calc(100vh - 400px);max-height: calc(100vh - 400px); overflow-y: auto;"
              class="mx-2 px-2">
              <div class="fw-semibold font-size-14">Gắn tag cho liên hệ</div>
              <div style="border:1px solid #DCDFE9 " class="p-1 mt-2">
                <div class="p-2 d-flex justify-content-start flex-wrap " style="overflow-y: auto ;max-height: 200px;">
                  <div v-for="item in app.tags" :key="item.id">
                    <div @click="selectTag(item.id)">
                      <TagCustom :item="item" :selected="isSelected(item.id)" :is-button="true" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-2 d-flex justify-content-end">
            <el-button size="mini" type="danger" plain @click="close()">Hủy</el-button>
            <el-button size="mini" type="primary" @click="save()">Lưu</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="getTitle()" :visible.sync="showPopupMessage" :close-on-click-modal="false" width="30%"
               destroy-on-close>
      <div>
        <el-input type="textarea" placeholder="Nhập nội dung tin nhắn" :row="2" v-model="messageText"></el-input>
        <div class="d-flex justify-content-end">
          <el-button type="primary" size="md" class="mt-2" @click="sendMessage()">Gửi</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="'Nhắn tin đến : ' + selectGroup.toName" :visible.sync="showPopupGroup"
               :close-on-click-modal="false" width="30%" destroy-on-close>
      <div>
        <el-input type="textarea" placeholder="Nhập nội dung tin nhắn" :row="2" v-model="messageText"></el-input>
        <div class="d-flex justify-content-end">
          <el-button type="primary" size="md" class="mt-2" @click="sendGroupMessage()">Gửi</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- <el-dialog title="Tạo nhóm" :visible.sync="showCreateGr" :close-on-click-modal="false" width="800px" top="40px"
      destroy-on-close @opened="setId()">
      <create-group ref="createGrMsg" :account-id="selectedAccount" />
    </el-dialog> -->

    <DialogCreateGroup
      v-if="showCreateGr"
      :dialogCreateGroup="showCreateGr"
      :account-id="selectedAccount"
      :userId="null"
      @close="showCreateGr = false" />
    <DialogSearchContact
      v-if="showAddFriend"
      @close="showAddFriend = false" />
    <!-- <el-dialog title="Tìm kiếm bằng số điện thoại" :visible.sync="showAddFriend" v-if="showAddFriend"
      width="900px"
      :close-on-click-modal="false" destroy-on-close> -->
    <!-- <SearchNewContact /> -->

    <!--      <div style="min-height: 500px">-->
    <!--        <el-input placeholder="Nhập số điện thoại" v-model="messageText" @input="searchUserByPhone()"></el-input>-->
    <!--        <div v-if="friendSearch.userId" class="mt-3">-->
    <!--          <ProfileInfoPopup :conversation="{toId:friendSearch.userId,accountId:selectedAccount}"-->
    <!--                            :data="friendSearch"></ProfileInfoPopup>-->
    <!--        </div>-->
    <!--      </div>-->
    <!-- </el-dialog> -->


    <div class="d-flex px-1 py-2 align-items-center">
      <div class="font-size-18 fw-bold">Chọn tài khoản</div>
      <el-select @change="changeAccount" v-model="selectedAccount" filterable default-first-option
                 placeholder="Tìm kiếm tài khoản..." size="mini" class="flex-1 w-200px mx-2">
        <el-option v-for="account in accounts" :key="account.accountId" :label="getAccountName(account)"
                   :value="account.accountId"></el-option>
      </el-select>
      <div class="flex-1" />
      <div class="d-flex">
        <el-tooltip class="item pointer mx-1" effect="dark" content="Tìm kiếm và kết bạn bằng số điện thoại"
                    placement="top">
          <el-button type="primary" class="font-size-14 d-flex" @click="showAddFriendPopup()">
            <div class="d-flex">
              <IconV2 name="v2-user-search" color="white"></IconV2>
              <div class="ms-1">Tìm liên hệ</div>
            </div>
          </el-button>
        </el-tooltip>
        <!-- <el-tooltip class="item pointer mx-1" effect="dark" content="Thêm nhiều liên hệ vào danh bạ salework"
          placement="top">
          <el-button type="primary" plain class="font-size-14 d-flex button-multiple" style=" border-radius: 3px"
            @click="addPhonePopup()">
            <div class="d-flex" @mouseenter="hoverState = true" @mouseleave="hoverState = false">
              <IconV2 name="v2-multiple" :color="hoverState ? '#ffffff' : '#1769D7'"></IconV2>
              <div class="ms-1">Thêm hàng loạt</div>
            </div>
          </el-button>
        </el-tooltip> -->
        <el-tooltip class="item pointer mx-1" effect="dark" content="Tạo nhóm mới" placement="top">
          <el-button plain class="font-size-14 d-flex"
                     style="border: 1px solid #3484F0; border-radius: 3px; color: #3484F0;"
                     @click="addGroup()">
            <div class="d-flex">
              <IconV2 name="v2-group-add" color="#3484F0"></IconV2>
              <div class="ms-1">Tạo nhóm mới</div>
            </div>
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <div class="divider-custom" />
    <div class="row p-0 m-0" style="height: 92%;
                              min-height: 570px;">
      <div class="d-flex bg-white px-1 py-2 flex-column"
           style="border-right: 1px solid #EEEEEE; width: 230px; flex-shrink: 0;">
        <div v-for="type in typeSelected" :key="type.val">
          <div @click="selectType(type.val)">
            <div v-bind:style="getMenuStyle(type)" effect="dark" style="margin-right: 4px;"
                 class="pointer text-center font-size-16">
              <div class="d-flex flex-row" style="height: 50px; margin-left: 10px;">
                <!-- <el-image :src="type.src" fit="fill" style="height: 50px;max-height: 100px;max-width: 20px;margin: 4px 6px" /> -->
                <div style="display: flex; align-items: center;">{{ type.name }}<span
                    v-if="type.val != 'setting' && type.val != 'sync'"
                    style="margin-left: 5px;"> ({{
                    getCount(type.val) }})</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-9" style="flex-grow: 1; padding: 0">
        <!-- <div class="divider-custom" /> -->
        <ContactListZalo v-show="selectedType === 'contact'" :selected-account="selectedAccount" />
        <ContactListSw v-show="selectedType === 'sw-contact'" :selected-account="selectedAccount" />
        <ContactListConversation v-show="selectedType === 'all'" :selected-account="selectedAccount" />
        <ContactListRecommend v-show="selectedType === 'recommend'" :selected-account="selectedAccount" />
        <LogFriendRequest v-show="selectedType === 'log'" :selected-account="selectedAccount" />
        <SyncData v-if="selectedType === 'sync'" :account-id="selectedAccount" />
      </div>
    </div>

  </div>
</template>

<script>
// import CreateGroup from "../components/contact/CreateGroup";
import { syncReadFile } from "../lib/file";
import ContactListZalo from "../components/contact/ContactListZalo";
import ContactListSw from "../components/contact/ContactListSw";
import ContactListConversation from "../components/contact/ContactListConversation";
import ContactListRecommend from "../components/contact/ContactListRecommend";
// import SearchNewContact from "../components/contact/SearchNewContact";
import TagCustom from "../components/common/TagCustom";
import LogFriendRequest from "@/components/contact/LogFriendRequest";
import DialogCreateGroup from "../components/message/DialogCreateGroup.vue";
import DialogSearchContact from "../components/contact/DialogSearchContact.vue";
import SyncData from "../components/SyncData";


var FileSaver = require("file-saver");
export default {
  components: {
    LogFriendRequest,
    TagCustom,
    // SearchNewContact,
    ContactListRecommend,
    ContactListConversation,
    ContactListSw,
    ContactListZalo,
    // CreateGroup,
    DialogCreateGroup,
    DialogSearchContact,
    SyncData
  },
  data() {
    return {
      searchKey: "",
      accounts: [],
      contacts: [],
      swContacts: [],
      swContactView: [],
      groups: [],
      selectedAccount: "",
      pageInfo: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      pageSwInfo: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      pageRequestedInfo: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      friendRequests: [],
      requestedFriends: [],
      requestedFriendsView: [],
      types: [
        { name: "Tất cả liên hệ", val: "all", src: "/assets/icon/ic_order.svg", color: "#0A58C0" },
        { name: "Danh sách bạn bè", val: "contact", src: "/assets/icon/ic_acc_contact.svg", color: "#CF4547" },
        { name: "Danh bạ Salework", val: "sw-contact", src: "/assets/icon/ic_sw_contact.svg", color: "#6c757d" },
        { name: "Lời mời kết bạn", val: "recommend", src: "/assets/icon/ic_recommend_contact.svg", color: "#1A6B44" },
        { name: "Nhật ký liên hệ", val: "log", src: "/assets/icon/graph.svg", color: "#17a2b8" },
        // { name: "Đồng bộ dữ liệu", val: "sync", src: "/assets/icon/ic_chat_1.svg", color: "#0A58C0" }
      ],
      selectedType: "all",
      totalContact: 0,
      showPopupMessage: false,
      showPopupGroup: false,
      selectContact: {},
      messageText: "",
      selectGroup: {},
      showAddFriend: false,
      showAddListPhone: false,
      friendSearch: {},
      isFr: false,
      showCreateGr: false,
      sortType: [{ name: "Tên (A-Z)", val: "az" }, { name: "Tên (Z-A)", val: "za" }],
      sortStatus: [
        { name: "Tất cả danh bạ", val: "all" },
        { name: "Chưa xử lý", val: "pending" },
        { name: "Đã xử lý", val: "success" },
        { name: "Lỗi", val: "error" }
      ],
      selectedSortStatus: "all",
      selectedSortType: "az",
      phoneNumbers: [],
      txtPhone: "",
      fileExample: ["0919283919\n", "0912345672\n", "0372718283\n"],
      addFr: false,
      contents: [{ content: "" }],
      listRecommendTab: [
        { name: "Tất cả phân loại", val: 0 },
        { name: "Đã nhận", val: 1 },
        { name: "Đã gửi", val: 2 }],
      selectedTab: 0,
      selectTagId: [],
      hoverState: false
    };
  },

  methods: {
    selectTag(id) {
      let indexOf = this.selectTagId.indexOf(id);
      if (indexOf > -1) {
        this.selectTagId.splice(indexOf, 1);
      } else {
        this.selectTagId.push(id);
      }
    },
    isSelected(id) {
      if (this.selectTagId.length > 0) {
        let indexOf = this.selectTagId.indexOf(id);
        if (indexOf > -1) {
          return true;
        }
      }
      return false;
    },
    getCount(type) {
      switch (type) {
        case "all": {
          return this.app.contactTotal.all;
        }
        case "contact": {
          return this.app.contactTotal.contact;
        }
        case "sw-contact": {
          return this.app.contactTotal.swContact;
        }
        case "recommend": {
          return this.app.contactTotal.recommend;
        }
        case "log": {
          return this.app.contactTotal.log;
        }
      }
    },
    addPhoneN(phone) {
      if (phone.trim().length === 0) return;
      if (phone.startsWith("+84")) {
        phone = "0" + phone.substring(3);
      } else if (phone.startsWith("84")) {
        phone = "0" + phone.substring(2);
      }
      const VN_PHONE_REGEX = /(84|0[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/g;
      let res = phone.match(VN_PHONE_REGEX);
      res.forEach(s => {
        let index = this.phoneNumbers.indexOf(s);
        if (index < 0) {
          this.phoneNumbers.push(s);
        }

      });
      this.txtPhone = "";
    },
    save() {
      if (this.phoneNumbers.length === 0) return this.alertError("Bạn chưa nhập số điện thoại.");
      let isEmpty = false;
      if (this.contents.length == 0) {
        isEmpty = true;
      } else {
        this.contents.forEach((it) => {
          if (it.content.length == 0) {
            isEmpty = true;
          }
        });
      }
      if (isEmpty && this.addFr) {
        this.alert("error", "Nội dung tin nhắn không được để trống.");
        return;
      }
      let tagIds = "";
      if (this.selectTagId.length > 0) {
        this.selectTagId.forEach(t => {
          tagIds = tagIds + t + ",";
        });
        tagIds = tagIds.substring(0, tagIds.length - 1);
      }
      let body = {
        accountId: this.selectedAccount,
        phones: this.phoneNumbers.map(p => {
          return p;
        }),
        addFr: this.addFr,
        contents: this.contents.map(p => {
          return p.content;
        }),
        tagIds: tagIds
      };
      this.$http.post("/api/contact/addSwContact", body).then(() => {
        this.alert("success", "Thêm liên hệ thành công.");
      });
      this.app.contactTotal.swContact += this.phoneNumbers.length;

      this.close();
    },
    close() {
      this.showAddListPhone = false;
    },
    activeMenuStyle(color) {
      //#0A58C0
      return {
        "border-radius": "4px",
        //   border: "2px solid " + this.setTransparencyHex(color, 0.1),
        "font-weight": "bold",
        color: color,
        // "background-color": this.setTransparencyHex(color, 0.1)
        "background-color": "#E1EDFD"
      };
    },
    normalMenuStyle(color) {
      //#696B72
      return {
        //   "border-radius": "4px",
        //   border: "2px solid " + this.setTransparencyHex(color, 0.1),
        color: color,
        "font-weight": "500",
        "background-color": "transparent"
      };
    },
    getMenuStyle(item) {
      return item.val == this.selectedType ? this.activeMenuStyle("#0A58C0") : this.normalMenuStyle("#696B72");
    },

    deleteContent(index) {
      this.contents.splice(index, 1);
    },
    addContent() {
      this.contents.push({ content: "" });
    },
    getTitle() {
      let title = "Gửi tin nhắn đến : " + (this.selectedType == "contact" ? this.selectContact.displayName : this.selectContact.name);
      return title;
    },
    _syncReadFile(file, callback) {
      return syncReadFile(file, callback);
    },

    downloadTxt() {
      var file = new File(this.fileExample, "file mau.txt", { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(file);
    },
    onChange() {
      let fileUpload = this.$refs.fileUpload.files[0];
      this._syncReadFile(fileUpload, text => {
        text.replaceAll("\r\n", "");
        let phoneNew = text.split("\n");
        phoneNew.forEach((p) => {
          this.addPhone(p.trim());
        });
      });
    },
    addPhone(phone) {
      try {
        if (phone.trim().length === 0) return;
        if (phone.startsWith("+84")) {
          phone = "0" + phone.substring(3);
        } else if (phone.startsWith("84")) {
          phone = "0" + phone.substring(2);
        }
        const VN_PHONE_REGEX = /(84|0[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/g;
        let res = phone.match(VN_PHONE_REGEX).map(function(s) {
          return s.trim();
        });
        res.forEach(s => {
          let index = this.phoneNumbers.indexOf(s);
          if (index < 0) {
            this.phoneNumbers.push(s);
          }

        });
      } catch (_) {
        //
      }
    },
    deletePhone(phone) {
      let index = this.phoneNumbers.indexOf(phone);
      if (index > -1) {
        this.phoneNumbers.splice(index, 1);
      }
    },
    upload() {
      this.$refs.fileUpload.click();
    },
    getAvatar(contact) {
      if (contact.avatar) {
        return contact.avatar;
      } else {
        return "/assets/images/no-avatar.png";
      }
    },

    setId() {
      this.$refs.createGrMsg.setAccountId(this.selectedAccount);
    },
    addGroup() {
      this.showCreateGr = true;
    },
    addFriend() {
      this.$http.get("/api/contact/addFriend", {
        params: {
          userId: this.friendSearch.uid,
          accountId: this.selectedAccount
        }
      }).then(() => {
        this.messageText = "";
        this.showAddFriend = false;
      });
    },
    showAddFriendPopup() {
      this.messageText = "";
      this.showAddFriend = true;
      this.friendSearch = {};
    },

    addPhonePopup() {
      this.selectTagId = [];
      this.phoneNumbers = [];
      this.txtPhone = "";
      this.showAddListPhone = true;
    },
    isVietnamesePhoneNumber(number) {
      return /((^(\+84|84|0|0084){1})(3|5|7|8|9))+([0-9]{8})$/.test(number);
    },
    searchUserByPhone() {
      this.isFr = false;
      let searchKey = this.messageText;
      this.friendSearch = {};
      if (searchKey.length < 9) return;
      if (searchKey.startsWith("0")) searchKey = "+84" + searchKey.substring(1);
      // if (!this.isVietnamesePhoneNumber(searchKey)) return;
      this.$http.get("/api/search/searchByPhoneAndAccount", {
        params: {
          searchKey: searchKey,
          accountId: this.selectedAccount
        }
      }).then(resp => {
        if (resp.data.error_code === 0) {
          let data = resp.data.data;
          this.getProfileInfo({
            avatar: data.avatar,
            name: data.display_name,
            uid: data.uid
          });
        }
        if ([216, 212].includes(resp.data.error_code)) {
          this.alertError("Số điện thoại chưa đăng ký tài khoản hoặc không cho phép tìm kiếm.");
        }
        if ([221].includes(resp.data.error_code)) {
          this.alertError("Vượt quá yêu cầu cho phép, vui lòng thử lại sau");
        }
      });
    },
    getProfileInfo(friendSearch) {
      this.$http.get("/api/search/getProfileInfo", {
        params: {
          uid: friendSearch.uid,
          accountId: this.selectedAccount
        }
      }).then(resp => {
        if (resp.data.error_code == 0) {
          let data = resp.data.data;
          this.friendSearch = data.changed_profiles[friendSearch.uid];
        }
      });
    },

    sendGroupMessage() {
      if (!this.messageText) {
        this.alert("error", "Nhập nội dung cần gửi.");
        return;
      }

      let request = {
        accountId: this.selectedAccount,
        groupId: this.selectGroup.id.toId,
        message: this.messageText
      };
      this.$http.post("/api/message/groupMsg", request).then(() => {
        this.messageText = "";
        this.showPopupGroup = false;
        this.alert("success", "Đã gửi tin nhắn");
      });

    },
    sendMessage() {
      if (!this.messageText) {
        this.alert("error", "Nhập nội dung cần gửi.");
        return;
      }

      let request = {
        accountId: this.selectedAccount,
        toId: this.selectedType == "contact" ? this.selectContact.id : this.selectContact.uid,
        message: this.messageText
      };
      this.$http.post("/api/message/sms", request).then(() => {
        this.messageText = "";
        this.showPopupMessage = false;
        this.alert("success", "Đã gửi tin nhắn");
      });

    },
    showMessage(contact) {
      this.messageText = "";
      this.selectContact = contact;
      this.showPopupMessage = true;
    },

    selectType(val) {
      this.selectedType = val;
      this.$router.push({ name: "Contact", hash: "#" + val });

    },
    changeAccount() {
      this.pageInfo.page = 1;
      this.pageSwInfo.page = 1;
      this.pageRequestedInfo.page = 1;
      this.searchKey = "";
    },
    searchByName() {
      this.pageInfo.page = 1;
    },
    getAccounts() {
      this.$http.get("/api/account/getAll").then(resp => {
        this.accounts = resp.data;

        if (this.accounts.length > 0) {
          this.selectedAccount = this.accounts[0].accountId;

        }
      });
    },

    getSource(data) {
      let source = data.recommInfo.source;
      if (source == 21) {
        return "Từ nhóm trò chuyện";
      } else if (source == 85) {
        return "Từ số điện thoại";
      } else {
        return "";
      }
    }
  },
  created() {
    this.getAccounts();
  },
  beforeDestroy() {
    this.$bus.$off("closeProfile");
    this.$bus.$off("closeCreateGrMsg");
  },
  mounted() {
    this.$bus.$on("closeCreateGrMsg", () => {
      this.showCreateGr = false;
    });
    this.$bus.$on("closeProfile", () => {
      if (!this.friendSearch.userId) return;
      this.getProfileInfo({ uid: this.friendSearch.userId });
    });
    if (!this.isContactUser()) {
      this.$router.push("/conversation");
    }

    if (this.$route.hash === "#all") {
      this.selectedType = "all";
    } else if (this.$route.hash === "#contact") {
      this.selectedType = "contact";
    } else if (this.$route.hash === "#sw-contact") {
      this.selectedType = "sw-contact";
    } else if (this.$route.hash === "#recommend") {
      this.selectedType = "recommend";
    } else if (this.$route.hash === "#setting") {
      this.selectedType = "setting";
    } else if (this.$route.hash === "#log"
    ) {
      this.selectedType = "log";
    } else if (this.$route.hash === "#sync") {
      this.selectedType = "sync";
    }
  },
  computed: {
    typeSelected() {
      if (this.isAdminUser()) {
        return this.types;
      } else {
        return this.types
          .filter(t => this.app.showListFriend || (t.val !== "contact" && t.val !== "recommend"))
          .filter(t => t.val !== "sw-contact" && t.val !== "log");
      }
    }
  }
};
</script>

<style scoped>


</style>
